//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/viz/circular_gauge'

//#endregion

import { EventsNames } from '../../../helpers/events-names'
import { DashboardGaugeDataModel } from '../../api/api.models'
import { DashboardRefreshControlDelay } from '../dashboard.controller'

//#region Asset Imports

import './meter.scss'
import * as TEMPLATE from './meter.tpl.html'

//#endregion

export class MeterDirective implements ng.IDirective {

    scope = {
        data: '=',
        itemTitle: '=',
        isEditMode: '='
    }

    restrict = 'E'
    link = (scope: ng.IScope, element: JQuery) => {

        scope.$on('dashboard-refresh', () => {
            alert('refresh dash')
            scope['gauge'].render()
        })

        let createOptions = () => {
            var data: DashboardGaugeDataModel = scope['data']

            if (!data)
                data = <any>{}

            scope['options'] = {
                geometry: {
                    startAngle: 220,
                    endAngle: -40
                },
                scale: {
                    startValue: data.min,
                    endValue: data.max,
                    tick: {
                        visible: true,
                        color: 'black'
                    },
                    minorTick: {
                        visible: true,
                        color: 'black'
                    }
                },
                value: data.value,
                valueIndicator: {
                    type: 'triangleNeedle',
                    color: 'black',
                    width: 6,
                    spindleGapSize: 0,
                    spindleSize: 0,
                    offset: 1
                },
                rangeContainer: {
                    ranges: data.ranges ? data.ranges.map(range => {
                        return {
                            color: range.color,
                            endValue: range.maxValue,
                            startValue: range.minValue
                        }
                    }) : null
                },
                size: {
                    height: 150
                },
                title: {
                    text: data.label ? data.label.description : '',
                    font: {
                        size: 14,
                        weight: 600
                    }
                },
                onInitialized: e => {
                    const gauge: DevExpress.viz.dxCircularGauge = e.component
                    scope['gauge'] = gauge

                    scope.$on(EventsNames.DASHBOARD_UPDATE_METER_SOURCE + scope['data'].id, (event, ...args: any[]) => {
                        const value: number = args[0]
                        gauge.value(value)
                    })

                    scope.$on(EventsNames.DASHBOARD_UPDATE, (event, ...args) => {
                        const delay = args[0]
                        delay.time += DashboardRefreshControlDelay

                        setTimeout(() => {
                            try {
                                gauge.render()
                            } catch (e) { }
                        }, delay.time)
                    })

                    scope.$on(EventsNames.UPDATE_DASHBOARD_ITEM + data.id, (event, ...args: any[]) => {
                        createOptions()
                        gauge.option(scope['options'])
                    })
                }
            }
        }

        createOptions()
    }
    template = TEMPLATE
    transclude = true
    replace = true
}